import { useMutation } from '@tanstack/react-query';

import { getCallRecordLinkFn } from './utils';

import type { GetCallRecordLinkProps } from './types';

export const useGetCallRecordLink = () => {
  const { mutateAsync, isLoading } = useMutation({
    mutationFn: async (dataProps: GetCallRecordLinkProps) =>
      getCallRecordLinkFn(dataProps),
  });

  return {
    getCallRecordLink: mutateAsync,
    getCallRecordLinkLoading: isLoading,
  };
};
